import React, {useEffect, useState} from 'react'
import {toAbsoluteUrl} from '../../../../../../_metronic/helpers'
import {QRCodeCanvas} from 'qrcode.react'

export const QrNh = ({valueBrcd, valueNameBro}: any) => {
  const handleGetlinkQR = () => {
    return `${window.location.origin}/open-account/auth?idBroker=${valueNameBro}&branchCd=${valueBrcd}&type=mg`
  }

  return (
    <div
      className='modal fade'
      tabIndex={-1}
      id='kt_modal_2'
      data-bs-backdrop='static'
      data-bs-keyboard='false'
      aria-labelledby='aboutUsLabel'
      aria-hidden='true'
    >
      <div className='modal-dialog'>
        <div className='modal-content'>
          <div className='modal-body mx-auto'>
            <QRCodeCanvas
              value={handleGetlinkQR()}
              size={327}
              bgColor={'#d8cade'}
              includeMargin={true}
            />
            ,
          </div>
          <div className='mx-4 mb-8'>
            Link:{' '}
            <a href={handleGetlinkQR()} className='px-5' target='_blank' rel='noreferrer'>
              Click để lấy link mở tài khoản
            </a>
          </div>
          <div className='modal-footer'>
            <button type='button' className='btn btn-primary' data-bs-dismiss='modal'>
              Đồng ý
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
